import { createFileRoute } from '@tanstack/react-router'
import { Resultado } from '@/features/medicao/Resultado'
import { measureSearch } from '@/lib/roomSearch'

/** Resultado da última coleta de deriva de uma sala. */
export const Route = createFileRoute('/measure')({
  validateSearch: measureSearch,
  component: function Measure() {
    const { room } = Route.useSearch()
    return <Resultado key={room} roomId={room} />
  },
})
